import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToastService } from './toasts.service';
import { catchError, Observable, of } from 'rxjs';
import { EventDTO } from '../models/events';
import * as requests from '../requests';

@Injectable({
  providedIn: 'root',
})
/*
Will just be for fetching/publishing events
*/
export class EventsService {
  private apiUrl = `${environment.apiUrl}/events`;

  constructor(private http: HttpClient, private toastService: ToastService) {}

  createEvent(request: requests.CreateEventRequest): Observable<EventDTO | null> {
    return this.http
      .post<EventDTO>(`${this.apiUrl}`, request, {
        withCredentials: true,
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      })
      .pipe(
        catchError(() => {
          this.toastService.show('Failed to create event', {
            classname: 'bg-danger text-light p-3 fs-5',
          });
          return of(null);
        })
      );
  }

  getEvents(): Observable<EventDTO[]> {
    return this.http
      .get<EventDTO[]>(`${this.apiUrl}`, { withCredentials: true })
      .pipe(
        catchError(() => {
          this.toastService.show('Failed to load user events', {
            classname: 'bg-danger text-light p-3 fs-5',
          });
          return of([]);
        })
      );
  }
}
